import React from "react";

const CheckboxButton = ({ handleClick, title, additionalClass = null }) => {
    return (
        <div className={additionalClass} style={{ marginTop: "6px" }}>
            <label className="btn btn-primary">
                <input type="checkbox" className="form-check-input" onChange={handleClick} />
                {title}
            </label>
        </div>
    );
};

export default CheckboxButton;
